import { render, staticRenderFns } from "./more-horiz.vue?vue&type=template&id=7a5cc94a"
import script from "./more-horiz.vue?vue&type=script&lang=js"
export * from "./more-horiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports